import { render, staticRenderFns } from "./OrganizationSettingsPage.vue?vue&type=template&id=46c0dc15&scoped=true"
import script from "./OrganizationSettingsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationSettingsPage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrganizationSettingsPage.vue?vue&type=style&index=0&id=46c0dc15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c0dc15",
  null
  
)

export default component.exports